import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./divisoes.component.html')
})
export class DivisoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/divisoes.component.ts
 **/